export default __webpack_public_path__ + "static/media/pic1.e92c920c.png";